import { render } from "./home-four.vue?vue&type=template&id=00cc3ea1"
import script from "./home-four.vue?vue&type=script&lang=js"
export * from "./home-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__